import { useEffect, useState } from "react";
import { Feedback } from "../../../admin.type";
import { getFeedback } from "modules/agentMySecurity/services/embeddingsService";
import AdvanceSearch from "core/components/global/advanceSearch/advanceSearch";
import { SimpleTableContainer } from "../../../admin.styled";
import AdminGroup from "./feedbackItem";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import NoResultsFound from "core/components/global/tables/noResults/noResultsFound";

const AdminFeedback = () => {
  const [copyOfSearchValue, setCopyOfSearchValue] = useState("");
  const [feedback, setFeedback] = useState<Feedback[]>([]);
  const [filteredFeedback, setFilteredFeedback] = useState<Feedback[] | null>(
    null
  );
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "ascending" | "descending" | null;
  }>({
    key: "",
    direction: null,
  });
  const [loading, setLoading] = useState(true);

  // Fetch the reports
  useEffect(() => {
    async function getFeedbackAsync() {
      try {
        setLoading(true);
        const response = await getFeedback();
        if (response === null) {
          setFeedback([]);
        } else {
          setFeedback(response);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching feedback:", error);
        setFeedback([]);
        setLoading(false);
      }
    }

    getFeedbackAsync();
  }, []);

  const handleFilterData = (newFeedback, b, c) => {
    setFilteredFeedback(newFeedback);
  };

  const handleClearFilter = () => {
    setFilteredFeedback(null);
  };

  // Sort functionality
  const requestSort = (key) => {
    let direction: "ascending" | "descending" | null = "ascending";

    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    } else if (
      sortConfig.key === key &&
      sortConfig.direction === "descending"
    ) {
      direction = "ascending";
    }

    setSortConfig({ key, direction });
  };

  // Get sorted data
  const getSortedData = () => {
    const dataToSort = filteredFeedback || feedback;
    if (!sortConfig.key || sortConfig.direction === null) return dataToSort;

    return [...dataToSort].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === "ascending" ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === "ascending" ? 1 : -1;
      }
      return 0;
    });
  };

  // Get sort icon
  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return null;

    if (sortConfig.direction === "ascending")
      return <ArrowUpwardIcon fontSize="small" />;
    if (sortConfig.direction === "descending")
      return <ArrowDownwardIcon fontSize="small" />;
    return null;
  };

  const sortedData = getSortedData();

  return (
    <>
      <SimpleTableContainer elevation={1} columns={3}>
        {/* Data Search */}
        <div className="pb-3 d-flex justify-content-between align-items-center">
          <h5>Feedback</h5>
          <AdvanceSearch
            initialData={feedback}
            setFilteredData={handleFilterData}
            clearFilteredData={handleClearFilter}
            setCopyOfSearchValue={setCopyOfSearchValue}
          />
        </div>

        {/* Collapsable Table */}
        <div aria-label="collapsible table">
          {/* Headers */}
          <div
            style={{ borderRadius: "5px 5px 0 0" }}
            className="outer-header-container"
          >
            <div className="row-items">
              <p
                className="header-item"
                onClick={() => requestSort("model")}
                style={{ cursor: "pointer" }}
              >
                Model {getSortIcon("model")}
              </p>
              <p
                className="header-item"
                onClick={() => requestSort("negative")}
                style={{ cursor: "pointer" }}
              >
                Sentiment {getSortIcon("negative")}
              </p>
              <p
                className="header-item"
                onClick={() => requestSort("createdAt")}
                style={{ cursor: "pointer" }}
              >
                Created At {getSortIcon("createdAt")}
              </p>
            </div>
            <div className="row-buttons"></div>
          </div>

          {/* Body */}
          <div
            style={{ borderRadius: "0 0 5px 5px", minHeight: "406px" }}
            className="outer-row-container"
          >
            {loading ? (
              <div className="p-3 text-center">Loading feedback data...</div>
            ) : sortedData && sortedData.length > 0 ? (
              <>
                {sortedData.map((item) => (
                  <AdminGroup key={`row-${item._id}`} feedbackItem={item} />
                ))}
              </>
            ) : (
              <>
                {/* If no results, show the NoResultsFound component */}
                <NoResultsFound
                  searchTerm={sortedData !== null ? copyOfSearchValue : ""}
                />
              </>
            )}
          </div>
        </div>
      </SimpleTableContainer>
    </>
  );
};

export default AdminFeedback;
